import Phaser from 'phaser';
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.CompleteTo10.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CompleteTo10.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.numbers = [];
  this.stars = [];
};

EDC.Games.CompleteTo10.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CompleteTo10.Scenes.Main.prototype.constructor = EDC.Games.CompleteTo10.Scenes.Main;

const CT10 = EDC.Games.CompleteTo10.Scenes.Main.prototype;

CT10.create = function () {
  this.initialize();

  this.createTemplateUI();
  this.loadIteration();

  this.createBasicUI();
};

CT10.loadIteration = function () {
  this.createNumbers();
  this.addStars();
};

CT10.createTemplateUI = function () {
  const title = this.add.sprite(515, 103, 'title').setOrigin(0);
  const instructions = this.add.sprite(490, 390, 'instructions').setOrigin(0);
  const grid = this.add.sprite(495, 515, 'grid').setOrigin(0);

  const rect = new Phaser.Geom.Rectangle(1080, 350, 300, 520);
  const hitArea = this.add.graphics({ fillStyle: { alpha: 0 } });
  hitArea.fillRectShape(rect);
  hitArea.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
  this.cursorManager.setDefaultDraggableEvents(hitArea);

  const buttonGreen = this.add.sprite(759, 961, 'button-green').setScale(0.51);
  const buttonRed = this.add.sprite(635, 961, 'button-red').setScale(0.5);
  this.colorAnim(buttonGreen, buttonRed);
};

CT10.colorAnim = function (sprite1, sprite2) {
  sprite1.setTint(0x999999);
  sprite2.setTint(0xffffff);
  this.time.delayedCall(1500, this.colorAnim2, [sprite1, sprite2], this);
};

CT10.colorAnim2 = function (sprite1, sprite2) {
  sprite1.setTint(0xffffff);
  sprite2.setTint(0x999999);
  this.time.delayedCall(1500, this.colorAnim, [sprite1, sprite2], this);
};

CT10.createNumbers = function () {
  for (let i = 0; i < 10; i++) {
    const { x, y } = this.getNumberPosition(i);
    const numberContainer = this.add.container(x + 50, y);
    const number = this.add.sprite(0, 0, `number-${i}`);
    numberContainer.numberText = i;
    numberContainer.add(number);
    numberContainer.setSize(88, 88);
    const rect = new Phaser.Geom.Rectangle(-50, 0, 88, 88);
    numberContainer.setInteractive(rect, Phaser.Geom.Rectangle.Contains);
    const markAnim = new AnswerMark(this, numberContainer).setScale(0.18);
    numberContainer.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(numberContainer);
    numberContainer.on('pointerup', this.checkAnswer.bind(this, numberContainer), this);
    numberContainer.on('pointerover', () => {
      numberContainer.first.setTint(0x0ffff0);
    });
    numberContainer.on('pointerout', () => {
      numberContainer.first.clearTint();
    });
    this.numbers.push(numberContainer);
  }
};

CT10.addStars = function () {
  const { stacked } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (stacked) {
    for (let i = 0; i < 10 - correctAnswer; i++) {
      const { x, y } = this.getStarPosition(i);
      const star = this.add.sprite(x, y, 'star');
      this.stars.push(star);
    }
  } else {
    const shuffledStars = this.shuffleStars(10 - correctAnswer);
    for (let i = 0; i < shuffledStars.length; i++) {
      const { x, y } = this.getStarPosition(shuffledStars[i]);
      const star = this.add.sprite(x, y, 'star');
      this.stars.push(star);
    }
  }
  this.shake();
};

CT10.getNumberPosition = function (i) {
  let x;
  let y;
  if (i === 0) {
    x = 1170;
    y = 436;
  } else if (i % 2 === 0) {
    x = 1170;
    y = 435 + i * 46;
  } else if (i % 2 !== 0) {
    x = 1275;
    y = 390 + i * 46;
  }

  return { x, y };
};

CT10.getStarPosition = function (i) {
  let x;
  let y;
  if (i < 5) {
    y = 605;
    x = 572 + i * 118;
  } else {
    y = 725;
    x = 572 + (i - 5) * 118;
  }
  return { x, y };
};

CT10.shuffleStars = function (starCount) {
  const starArray = new Array(starCount);
  for (let i = 0; i < starCount; i++) {
    const j = Math.round(Math.random() * 9);
    if (starArray.includes(j)) {
      i -= 1;
    } else {
      starArray[i] = j;
    }
  }
  return starArray;
};

CT10.checkAnswer = function (numberContainer) {
  const correct = numberContainer.numberText;
  const { correctAnswer } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  if (correct === correctAnswer) {
    this.playCorrect();
    this.numbers.map((x) => {
      x.disableInteractive();
      return true;
    });
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    numberContainer.first.setTint(0xff6347);
    numberContainer.removeInteractive();
    numberContainer.getData('markAnim').showMark(false, () => {});
  }
};

CT10.nextIteration = function () {
  this.numbers.map((x) => {
    x.destroy();
    return true;
  });
  this.numbers = [];
  this.stars.map((x) => {
    x.destroy();
    return true;
  });
  this.stars = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

CT10.shakeData = function () {
  this.stars.map((x) => {
    x.angle = -3;
    return true;
  }, this);

  this.tweens.add({
    targets: this.stars.map(star => star),
    angle: 3,
    duration: 60,
    ease: 'Sine.easeInOut',
    repeat: 3,
    yoyo: true,
    onComplete: this.shake(this.stars),
  });
};

CT10.shake = function () {
  this.stars.map((x) => {
    x.angle = 0;
    return true;
  }, this);
  const rndTime = 5000 + Math.round(Math.random() * 3000);
  this.time.addEvent({ delay: rndTime, callback: this.shakeData, callbackScope: this });
};

export default EDC.Games.CompleteTo10.Scenes.Main;
